import { useState } from 'react';
import { testRequest } from '../helpers/test-data';

const Form = ( ) => {

    const [randomData, setRandomData] = useState(testRequest())
    const [, setSelectedProduct] = useState('');

    function handleProductChange(event) {
        setSelectedProduct(event.target.value);
    }

    function handleSubmit(event) {
        event.preventDefault();

        const prevData = JSON.parse(localStorage.getItem('submittedData')) || [];
        const lastId = prevData.length > 0 ? prevData[prevData.length - 1].id : 0;
        const updatedData = [...prevData, {...randomData, id: lastId + 1, date: new Date().toISOString(),status: 'new'}];
        localStorage.setItem('submittedData', JSON.stringify(updatedData));
        setRandomData(testRequest())
    }

    return ( 
        <form id="form" method="POST" onSubmit={handleSubmit}>
            <label>Ваши данные:</label>
            <div className="form-group">
                <input id="name" 
                        type="text" 
                        name="name" 
                        autoComplete="on" 
                        className="form-control" 
                        placeholder="Имя и Фамилия"
                        onChange={(e) => setRandomData({...randomData, fullName: e.target.value})} 
                        required value={randomData?.fullName || ''}></input>
            </div>
            <div className="form-group">
                <input id="phone" 
                        type="text" 
                        name="phone" 
                        autoComplete="on" 
                        className="form-control" 
                        placeholder="Телефон" 
                        onChange={(e) => setRandomData({...randomData, phone: e.target.value})}
                        value={randomData?.phone || ''}></input>
            </div>
            <div className="form-group">
                <input id="email" 
                    type="email" 
                    name="email" 
                    autoComplete="on" 
                    className="form-control" 
                    placeholder="Email" 
                    onChange={(e) => setRandomData({...randomData, email: e.target.value})}
                    required value={randomData?.email || ''}></input>
            </div>
            <div className="form-group">
                <label htmlFor="product">Продукт:</label>
                <select id="product" name="product" className="form-control" value={randomData?.product || ''} onChange={handleProductChange}>
                    <option value="course-html">Курс по верстке</option>
                    <option value="course-js">Курс по JavaScript</option>
                    <option value="course-vue">Курс по VUE JS</option>
                    <option value="course-php">Курс по PHP</option>
                    <option value="course-wordpress">Курс по WordPress</option>
                </select>
            </div>
            <div className="form-group">
                <button type="submit" className="btn btn-lg btn-primary btn-block"> Оформить заявку</button>
            </div>
        </form>
     );
}
 
export default Form;